import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import StoreUtil from "../store.util.js";

const state = {
  employeeList: StoreUtil.state(),
};

const ianagedInstructionModule = {
  state,
  mutations,
  actions,
  getters,
};

export default ianagedInstructionModule;
